<ul class="sub-links-list">
    @for (btnLink of links(); track btnLink) {
        <li>
            @if (btnLink.isAngularPage) {
                <!-- $any: btnLink.queryParams is optional but smart-router-link types the input as `object`.
                     Passing undefined is the existing behaviour (it used to reach here through an untyped
                     ng-template context) and matters - `?? {}` would make the truthy check in
                     smart-router-link strip the query string off links that carry one. -->
                <smart-router-link
                    (click)="$event.stopPropagation()"
                    [link]="btnLink.link"
                    [queryParams]="$any(btnLink.queryParams)"
                    [isRouterLink]="isAngularApp()"
                >
                    <span>{{ btnLink.name }}</span>
                </smart-router-link>
            } @else {
                <a [href]="btnLink.link" (click)="$event.stopPropagation()">
                    <span>{{ btnLink.name }}</span>
                </a>
            }
        </li>
    }
</ul>
